/**
 * Product Card Slider Component using Flickity
 * Handles image slider functionality with Instagram-style rapid swiping
 */

(function() {
  'use strict';

  // Prevent multiple initializations
  if (window.productCardSliderInitialized) {
    return;
  }
  window.productCardSliderInitialized = true;

  // Load Flickity from CDN if not already loaded
  if (typeof Flickity === 'undefined') {
    // Load Flickity CSS
    const flickityCSS = document.createElement('link');
    flickityCSS.rel = 'stylesheet';
    flickityCSS.href = 'https://unpkg.com/flickity@2/dist/flickity.min.css';
    document.head.appendChild(flickityCSS);

    // Load Flickity JS
    const flickityScript = document.createElement('script');
    flickityScript.src = 'https://unpkg.com/flickity@2/dist/flickity.pkgd.min.js';
    flickityScript.onload = () => {
      initProductCardSliders();
    };
    document.head.appendChild(flickityScript);
  } else {
  }

  const initializedSliders = new WeakSet();
  const flickityInstances = new WeakMap(); // Store Flickity instances for reinitialization

function initProductCardSliders() {
  if (typeof Flickity === 'undefined') {
    setTimeout(initProductCardSliders, 100);
    return;
  }

  const sliders = document.querySelectorAll('[data-product-slider]');
  sliders.forEach((sliderElement, index) => {
    if (initializedSliders.has(sliderElement)) {
      return;
    }
    
    try {
      initSingleSlider(sliderElement);
      initializedSliders.add(sliderElement);
    } catch (error) {
      console.error('Error initializing slider:', error);
    }
  });
}

function initSingleSlider(sliderElement) {
  const imageWrapper = sliderElement.closest('.product-card__image-wrapper');
  if (!imageWrapper) return;

  const productLink = imageWrapper.querySelector('.product-card__link');
  const productCardWrapper = imageWrapper.closest('.product-card__wrapper');
  
  // Ensure all cells are properly contained before initialization
  const cells = sliderElement.querySelectorAll('.product-card__slider-cell');
  cells.forEach(cell => {
    // Make sure cells are direct children of slider element
    if (cell.parentElement !== sliderElement) {
      sliderElement.appendChild(cell);
    }
  });
  
  // Initialize Flickity
  const flkty = new Flickity(sliderElement, {
    // Cell/slide settings
    cellAlign: 'center',
    contain: true,
    spaceBetween: 1,
    
    // Interaction - ALLOW PAGE SCROLLING
    draggable: '>1', // Only draggable if more than 1 slide (allows vertical scroll)
    freeScroll: false,
    wrapAround: false,
    
    // Pagination
    pageDots: false,
    
    // Navigation arrows
    prevNextButtons: false,
    
    // CRITICAL: Remove ALL bounce/elasticity
    friction: 0.8,
    selectedAttraction: 0.2,
    freeScrollFriction: 0.8,
    
    // Strict boundaries - NO BOUNCE
    dragThreshold: 10, // Higher threshold - only horizontal drags, allows vertical scroll
    accessibility: true,
    setGallerySize: true,
    resize: true,
    percentPosition: false,
    staticClick: true,
    
    // Prevent positioning bugs
    imagesLoaded: true,
    lazyLoad: false,
  });

  // Custom pagination with sliding active dot
  const paginationEl = productCardWrapper?.querySelector('.product-card__slider-pagination');
  if (paginationEl) {
    const dots = paginationEl.querySelectorAll('.product-card__slider-dot');
    const activeDot = paginationEl.querySelector('.product-card__slider-dot-active');
    const totalSlides = parseInt(paginationEl.getAttribute('data-total-slides')) || dots.length;
    
    // Calculate and set the width of the active dot indicator
    if (activeDot && totalSlides > 0) {
      const dotWidth = 100 / totalSlides;
      activeDot.style.width = dotWidth + '%';
      
      // Update active dot position on change
      flkty.on('change', (index) => {
        const translateX = index * 100;
        activeDot.style.transform = `translateX(${translateX}%)`;
      });
    }
    
    // Click dots to navigate
    dots.forEach((dot, index) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        flkty.select(index);
      });
    });
  }

  // Custom navigation arrows with disabled states
  const nextEl = imageWrapper.querySelector('.product-card__slider-arrow--next');
  const prevEl = imageWrapper.querySelector('.product-card__slider-arrow--prev');
  
  // Function to update arrow states
  function updateArrowStates() {
    if (prevEl) {
      if (flkty.selectedIndex === 0) {
        prevEl.setAttribute('disabled', 'true');
        prevEl.classList.add('swiper-button-disabled');
      } else {
        prevEl.removeAttribute('disabled');
        prevEl.classList.remove('swiper-button-disabled');
      }
    }
    
    if (nextEl) {
      if (flkty.selectedIndex === flkty.cells.length - 1) {
        nextEl.setAttribute('disabled', 'true');
        nextEl.classList.add('swiper-button-disabled');
      } else {
        nextEl.removeAttribute('disabled');
        nextEl.classList.remove('swiper-button-disabled');
      }
    }
  }
  
  // Update arrow states on slide change
  flkty.on('change', () => {
    updateArrowStates();
  });
  
  // Set initial arrow states
  updateArrowStates();
  
  if (nextEl) {
    nextEl.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!nextEl.hasAttribute('disabled')) {
        flkty.next();
      }
    });
  }
  
  if (prevEl) {
    prevEl.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!prevEl.hasAttribute('disabled')) {
        flkty.previous();
      }
    });
  }

  // Prevent link click during drag
  let isDragging = false;
  let dragStartX = 0;
  const clickThreshold = 5;

  flkty.on('dragStart', () => {
    isDragging = true;
    dragStartX = flkty.x;
  });

  flkty.on('dragMove', () => {
    const dragDistance = Math.abs(flkty.x - dragStartX);
    if (dragDistance > clickThreshold && productLink) {
      productLink.style.pointerEvents = 'none';
    }
  });

  flkty.on('dragEnd', () => {
    setTimeout(() => {
      isDragging = false;
      if (productLink) {
        productLink.style.pointerEvents = '';
      }
    }, 100);
  });

  // Prevent link click if dragged
  if (productLink) {
    productLink.addEventListener('click', (e) => {
      if (isDragging) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    }, true);
  }

  // Wait for images to load, then resize
  const images = sliderElement.querySelectorAll('img');
  let loadedImages = 0;
  const totalImages = images.length;

  function checkAllImagesLoaded() {
    loadedImages++;
    if (loadedImages === totalImages) {
      setTimeout(() => {
        flkty.resize();
        flkty.reloadCells();
      }, 50);
    }
  }

  // Prevent image dragging and track loading
  images.forEach(img => {
    img.addEventListener('dragstart', (e) => {
      e.preventDefault();
      return false;
    });

    // Wait for image load
    if (img.complete) {
      checkAllImagesLoaded();
    } else {
      img.addEventListener('load', checkAllImagesLoaded);
      img.addEventListener('error', checkAllImagesLoaded);
    }
  });

  // Prevent link dragging
  sliderElement.querySelectorAll('a').forEach(el => {
    el.addEventListener('dragstart', (e) => {
      e.preventDefault();
      return false;
    });
  });

  // Verify cells are properly contained in viewport
  function verifyCellsInViewport() {
    const viewport = sliderElement.querySelector('.flickity-viewport');
    const slider = sliderElement.querySelector('.flickity-slider');
    
    if (viewport && slider) {
      const cells = sliderElement.querySelectorAll('.product-card__slider-cell');
      cells.forEach(cell => {
        // Ensure cells are inside the slider (which is inside viewport)
        if (cell.parentElement !== slider && !slider.contains(cell)) {
          slider.appendChild(cell);
        }
      });
      
      // Force Flickity to recount and reposition cells
      flkty.reloadCells();
      flkty.resize();
    }
  }

  // Force initial resize after a short delay
  setTimeout(() => {
    flkty.resize();
    verifyCellsInViewport();
  }, 100);

  // Force another resize after more time
  setTimeout(() => {
    flkty.resize();
    verifyCellsInViewport();
  }, 500);

  // Additional verification after longer delay (for lazy-loaded content)
  setTimeout(() => {
    verifyCellsInViewport();
  }, 1000);

  // Watch for any cells that might appear outside viewport
  if (window.MutationObserver) {
    const cellObserver = new MutationObserver((mutations) => {
      let needsCheck = false;
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.classList && node.classList.contains('product-card__slider-cell')) {
              needsCheck = true;
            }
          });
        }
      });
      
      if (needsCheck) {
        setTimeout(() => verifyCellsInViewport(), 50);
      }
    });
    
    cellObserver.observe(sliderElement, {
      childList: true,
      subtree: false
    });
  }

  // Store the Flickity instance for later access
  flickityInstances.set(sliderElement, flkty);
  return flkty;
}

// Function to resize all existing Flickity instances
function resizeAllSliders() {
  const sliders = document.querySelectorAll('[data-product-slider]');

  sliders.forEach((sliderElement) => {
    const flkty = flickityInstances.get(sliderElement);
    if (flkty && typeof flkty.resize === 'function') {
      // Force Flickity to recalculate dimensions
      flkty.resize();
      flkty.reloadCells();
    }
  });
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(initProductCardSliders, 100);
  });
} else {
  setTimeout(initProductCardSliders, 100);
}

document.addEventListener('shopify:section:load', () => {
  setTimeout(initProductCardSliders, 100);
});
document.addEventListener('shopify:section:reorder', () => {
  setTimeout(initProductCardSliders, 100);
});

// Reinitialize sliders after collection filters/sorting are applied
document.addEventListener('collection:rerendered', () => {
  setTimeout(initProductCardSliders, 150);
});

// Listen for layout change event from LayoutSwitcher
document.addEventListener('layout:changed', (e) => {
  
  // Wait for CSS transitions to complete, then resize sliders
  setTimeout(() => {
    resizeAllSliders();
  }, 50);
  
  // Additional resize after longer delay to ensure everything is settled
  setTimeout(() => {
    resizeAllSliders();
  }, 300);
});

// Listen for filter toggle button clicks and resize sliders
document.addEventListener('click', (e) => {
  const filterToggle = e.target.closest('.tm-toggle-filters');
  if (filterToggle) {
    
    // Wait for layout shift to complete, then resize
    setTimeout(() => {
      resizeAllSliders();
    }, 50);
    
    // Additional resize after longer delay
    setTimeout(() => {
      resizeAllSliders();
    }, 350);
  }
});

// Also listen for when ProductGridContainer innerHTML changes (backup method)
if (window.MutationObserver) {
  const observeProductGrid = () => {
    const productGridContainer = document.getElementById('ProductGridContainer');
    const productsList = document.getElementById('ProductsList');
    
    if (!productGridContainer) return;

    // Observe content changes
    const contentObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          setTimeout(initProductCardSliders, 100);
        }
      });
    });

    contentObserver.observe(productGridContainer, {
      childList: true,
      subtree: false
    });

    // Observe class changes on ProductsList (for layout switching)
    if (productsList) {
      const layoutObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            setTimeout(initProductCardSliders, 150);
          }
        });
      });

      layoutObserver.observe(productsList, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  };

  // Observe on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeProductGrid);
  } else {
    observeProductGrid();
  }
}

})(); // End of IIFE
